import { observable, action, computed } from "mobx";

const defaultData = {
  isOpen: false,
  header: "",
  content: "",
  acceptLabel: "Ok",
  cancelLabel: "",
  acceptCallback: null,
  cancelCallback: null,
};

export default class Alert {
  @observable isOpen;

  @observable header;

  @observable content;

  @observable acceptLabel;

  @observable cancelLabel;

  @observable acceptCallback;

  @observable cancelCallback;

  constructor({
    isOpen = defaultData.isOpen,
    header = defaultData.header,
    content = defaultData.content,
    acceptLabel = defaultData.acceptLabel,
    cancelLabel = defaultData.cancelLabel,
    acceptCallback = defaultData.acceptCallback,
    cancelCallback = defaultData.cancelCallback,
  }) {
    this.isOpen = isOpen;
    this.header = header;
    this.content = content;
    this.acceptLabel = acceptLabel;
    this.cancelLabel = cancelLabel;
    this.acceptCallback = acceptCallback;
    this.cancelCallback = cancelCallback;
  }

  @action
  open() {
    this.isOpen = true;
  }

  @action
  close() {
    this.isOpen = false;
  }

  @computed get hasCancelButton() {
    return this.cancelLabel !== "";
  }

  @action
  accept() {
    if (this.acceptCallback) {
      const promise = this.acceptCallback();
      // if accept callback returns a promise, then we should return it as well.
      if (promise && typeof promise.then === "function") {
        return promise;
      }
    }

    // if no acceptCallback or no promise is returned, then just close.
    this.close();

    return null;
  }

  @action
  cancel() {
    if (this.cancelCallback) {
      this.cancelCallback();
    }

    this.resetData();
  }

  @action
  resetData() {
    this.isOpen = defaultData.isOpen;
    this.header = defaultData.header;
    this.content = defaultData.content;
    this.acceptLabel = defaultData.acceptLabel;
    this.cancelLabel = defaultData.cancelLabel;
    this.acceptCallback = defaultData.acceptCallback;
    this.cancelCallback = defaultData.cancelCallback;
  }
}
